export const FileTypes = {
    avi: {
        name: 'AVI',
        type: 'video',
        icon: 'fal fa-video',
        img: false,
        color: '#2276b2',
    },
    dwg: {
        name: 'DWG',
        type: 'image',
        icon: 'fal fa-image',
        img: false,
    },
    jpeg: {
        name: 'JPEG',
        type: 'image',
        icon: 'fal fa-image',
        img: true,
    },
    jpg: {
        name: 'JPG',
        type: 'image',
        icon: 'fal fa-image',
        img: true,
    },
    m2v: {
        name: 'M2V',
        type: 'video',
        icon: 'fal fa-video',
        img: false,
    },
    m4p: {
        name: 'M4P',
        type: 'audio',
        icon: 'fal fa-music',
        img: false,
    },
    m4v: {
        name: 'M4V',
        type: 'video',
        icon: 'fal fa-video',
        img: false,
    },
    mkv: {
        name: 'MKV',
        type: 'video',
        icon: 'fal fa-video',
        img: false,
    },
    mov: {
        name: 'MOV',
        type: 'video',
        icon: 'fal fa-video',
        img: false,
    },
    mp2: {
        name: 'MP2',
        type: 'audio',
        icon: 'fal fa-music',
        img: false,
    },
    mp4: {
        name: 'MP4',
        type: 'video',
        icon: 'fal fa-video',
        img: false,
    },
    mpe: {
        name: 'MPE',
        type: 'video',
        icon: 'fal fa-video',
        img: false,
    },
    mpeg: {
        name: 'MPEG',
        type: 'video',
        icon: 'fal fa-video',
        img: false,
    },
    mpg: {
        name: 'MPG',
        type: 'video',
        icon: 'fal fa-video',
        img: false,
    },
    mpv: {
        name: 'MPV',
        type: 'video',
        icon: 'fal fa-video',
        img: false,
    },
    ogg: {
        name: 'MP2',
        type: 'audio',
        icon: 'fal fa-music',
        img: false,
    },
    ogv: {
        name: 'OGV',
        type: 'video',
        icon: 'fal fa-video',
        img: false,
    },
    pdf: {
        name: 'PDF',
        type: 'file',
        icon: 'fal fa-pdf',
        img: false,
        color: '#f40f02',
    },
    png: {
        name: 'PNG',
        type: 'image',
        icon: 'fal fa-image',
        img: true,
    },
    webm: {
        name: 'WEBM',
        type: 'video',
        icon: 'fal fa-video',
        img: false,
    },
    wmv: {
        name: 'WMV',
        type: 'video',
        icon: 'fal fa-video',
        img: false,
    },
    docx: {
        name: 'docx',
        type: 'document',
        icon: 'fal fa-file',
        img: false,
        color: '#2b5496',
    },
}
